





































































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mutations } from '@/ts/store/Constants';

@Component({
    computed: {
        ...mapGetters({
            confirmQuestionText: 'ConfirmPopup/getConfirmQuestionText',
            confirmInfoText: 'ConfirmPopup/getConfirmInfoText',
            confirmButton: 'ConfirmPopup/getConfirmButton',
            confirmIcon: 'ConfirmPopup/getConfirmIcon',
            confirmHeaderText: 'ConfirmPopup/getConfirmHeaderText',
            confirmButtonClass: 'ConfirmPopup/getConfirmButtonClass',
        }),
    },
})
export default class ConfirmPopup extends Vue {
    constructor() {
        super();
    }

    public executeAction() {
        const execAction = this.$store.getters['ConfirmPopup/getConfirmAction'];
        const execActionData = this.$store.getters['ConfirmPopup/getConfirmActionData'];

        if (execAction === 'redirectToUnitLanding') {
            this.$router.push({ name: 'admin-unit-details', params: { unitId: execActionData.propertyId } });
            this.cancel();
        } else {
            this.$store.dispatch(execAction, execActionData);
        }
    }

    public cancel() {
        this.$store.commit(Mutations.RESET_CONFIRM_POPUP_DATA);
    }

    public destroyed() {
        this.cancel();
    }
}
